import api from 'api'

type RemoveRuleJurisdictionRequest = {
  ruleId: number
  jurisdictionId: number
}

export const removeRuleJurisdiction = async (
  request: RemoveRuleJurisdictionRequest
): Promise<void> => {
  await api.delete(
    `/admin/wage/rules/${request.ruleId}/jurisdictions/${request.jurisdictionId}`
  )
}
